/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Title_LeadInputs */

const en_portal_view_title_lead = /** @type {(inputs: Portal_View_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach sees`)
};

const pl_portal_view_title_lead = /** @type {(inputs: Portal_View_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój trener widzi`)
};

/**
* | output |
* | --- |
* | "Your coach sees" |
*
* @param {Portal_View_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_title_lead = /** @type {((inputs?: Portal_View_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_title_lead(inputs)
	return en_portal_view_title_lead(inputs)
});